export const TECH_DRIVE_REFS = [
  'bridge_offline',
  'bridge_online',
  'upload_resume',
  'instah_campaign',
];
